import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  flex: 1 0 0;

  padding: 10px;

  gap: 30px;

  overflow: auto;

  @media screen and (max-width: 768px) {
    padding: 0;
  }
`;

interface TitleItemProps {
  margin?: string;
}

export const TitleItem = styled.p<TitleItemProps>`
  font-family: 'DM Sans', sans-serif;
  font-style: normal;
  letter-spacing: 0.2px;

  color: #101010;

  font-size: 20px;

  font-weight: 500;

  margin: ${({ margin }) => margin || '0'};
`;

export const Panel = styled.div`
  width: 100%;
  height: 100%;
  height: 980px;
  min-height: 980px;

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  align-items: flex-start;
  justify-content: flex-start;

  flex: 1 0 0;

  background: #ffffff;

  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);

  padding-left: 24px;

  border-radius: 10px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    min-height: fit-content;

    padding: 0;
  }
`;

export const LeftBar = styled.div`
  width: 323px;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  padding-right: 24px;

  border-right: 1px solid #efefef;

  @media screen and (max-width: 768px) {
    flex-direction: row;

    width: 100%;
    padding: 0;

    border: none;

    margin-top: -12px;
  }
`;

interface MenuItemsProps {
  isLastItem?: boolean;
  isSelected?: boolean;
  isFirstItem?: boolean;
}

export const MenuItems = styled.a<MenuItemsProps>`
  width: 100%;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  gap: 8px;

  padding: 8px 16px 14px 16px;
  margin-top: 14px;

  text-align: left;

  background: transparent;

  border: none;
  border-bottom: ${({ isLastItem }) => (isLastItem ? 'none' : '1px solid #efefef')};

  cursor: pointer;

  transition: all 0.2s;

  > p {
    width: 100%;

    font-family: Manrope, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.48px;

    color: ${({ isSelected }) => (isSelected ? '#5768FF;' : '#858585')};
  }

  > svg {
    opacity: ${({ isSelected }) => (isSelected ? 1 : 0)};

    transition: all 0.2s;
  }

  &:hover {
    color: #3f4cbd;

    > svg {
      opacity: 1;
    }
  }

  @media screen and (max-width: 768px) {
    border: none;

    padding: 6px 10px;

    background: ${({ isSelected }) => (isSelected ? '#5768FF;' : 'transparent')};

    border-radius: ${({ isFirstItem, isLastItem }) =>
      isFirstItem ? '10px 0 0 0' : isLastItem ? '0 10px 0 0' : '0'};

    > p {
      text-align: center;
      color: ${({ isSelected }) => (isSelected ? '#EFEFEF' : '#858585')};
    }

    > svg {
      display: none;
    }
  }
`;

export const ButtonDeleteAccount = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;

  padding: 8px 16px;

  margin: 36px 0;

  background: transparent;
  border: none;

  color: #d81e5b;
  text-align: center;

  font-family: Manrope, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.48px;

  cursor: pointer;

  transition: all 0.5s;

  &:hover {
    filter: brightness(0.7);
  }

  @media screen and (max-width: 768px) {
    align-items: center;
    text-align: center;

    margin: 0 auto 18px auto;

    background: transparent;
  }
`;

export const RightArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;

  padding: 24px;

  gap: 30px;

  > span > div.ant-upload-select-picture-card {
    border: none;
  }
`;

export const EditAvatarItem = styled.div`
  position: absolute;

  display: flex;
  align-items: center;
  justify-content: center;

  bottom: 0;
  right: 0;

  width: 24px;
  height: 24px;

  border-radius: 35px;

  background: #5768ff;

  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.04);

  z-index: 2;
`;

export const AvatarArea = styled.div`
  position: relative;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 86px;
  height: 86px;
  border-radius: 120px;

  border-radius: 120px;

  background: #efefef;
  border: 2px solid #5768ff;

  > img {
    width: 82px;
    height: 82px;
    border-radius: 120px;
  }
`;

export const NameLetterIcon = styled.p`
  font-family: Manrope, sans-serif;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 48px;
  letter-spacing: 0.96px;

  color: #5768ff;

  width: 82px;
  height: 82px;
`;

const ButtonDeleteArea = styled.div`
  width: 100%;

  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  gap: 8px;
`;

export const ButtonDeleteMenuArea = styled(ButtonDeleteArea)`
  display: flex;

  margin-top: auto;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const ButtonDeleteFooterArea = styled(ButtonDeleteArea)`
  display: none;
  margin-top: 48px;
  margin-bottom: -24px;

  @media screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
  }
`;

export const ModalUploadProfilePhoto = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 650px;

  width: fit-content;
  height: fit-content;

  background-color: #fff;

  border-radius: 3px;

  padding: 24px;

  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.5);

  > div > div {
    cursor: crosshair;
  }
`;

export const HeaderModalProfilePhoto = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 24px;
  > h2 {
    display: flex;
    flex-direction: column;

    font-family: Manrope, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px;
    letter-spacing: 0.72px;
    color: #101010;
    > span {
      font-size: 12px;
      font-weight: normal;
      margin-top: -10px;
    }
  }
  > button {
    background: transparent;
    border: none;
    cursor: pointer;
    > svg {
      width: 24px;
      height: 24px;
      color: #101010;
    }
  }

  @media screen and (max-width: 768px) {
    > h2 {
      font-size: 20px;
      line-height: 30px;
      letter-spacing: 0.6px;
    }
    > button {
      > svg {
        width: 20px;
        height: 20px;
        color: #101010;
      }
    }
  }
`;

const ButtonBase = styled.button`
  width: fit-content;
  min-width: 82px;
  height: fit-content;
  min-height: 40px;

  padding: 8px 16px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 6px;
  border: none;

  font-family: Manrope, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.48px;

  color: #ffffff;

  cursor: pointer;

  transition: all 0.2s;

  &:hover {
    filter: brightness(0.9);
    box-shadow: none;
    transform: translateY(-1px);
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: ease-in-out;
    transition-delay: initial;
  }
`;

export const ButtonSave = styled(ButtonBase)`
  background: #5768ff;
`;

export const ButtonCancel = styled(ButtonBase)`
  background: rgb(117, 117, 117);
`;

export const ButtonsArea = styled.div`
  width: fit-content;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 12px;

  margin-left: auto;
  margin-top: 12px;
`;
